// src/utils/track.js 

const ENDPOINT = "https://api.torolm.com";

function safeString(v, max = 300) {
  if (v === undefined || v === null) return null;
  const s = String(v);
  return s.length > max ? s.slice(0, max) : s;
}

export function getCommonContext(extra = {}) {
  const params = new URLSearchParams(window.location.search);

  return {
    path: window.location.pathname,
    referrer: document.referrer || null,
    user_agent: navigator.userAgent || null,
    language: navigator.language || null,
    screen_w: window.screen?.width ?? null,
    screen_h: window.screen?.height ?? null,
    viewport_w: window.innerWidth ?? null,
    viewport_h: window.innerHeight ?? null,

    utm_source: safeString(params.get("utm_source")),
    utm_medium: safeString(params.get("utm_medium")),
    utm_campaign: safeString(params.get("utm_campaign")),
    utm_content: safeString(params.get("utm_content")),
    utm_term: safeString(params.get("utm_term")),
    gclid: safeString(params.get("gclid")),
    fbclid: safeString(params.get("fbclid")),

    ...extra,
  };
}

function ga4(event, payload) {
  if (typeof window.gtag !== "function") return;
  try {
    window.gtag("event", event, payload);
  } catch {}
}

export async function track(event, props = {}, options = {}) {
  const body = { event, props, ts: new Date().toISOString() };

  ga4(event, props);

  try {
    const headers = { "Content-Type": "application/json" };

    const token = process.env.REACT_APP_WEB_TRACKING_TOKEN;
    if (token) headers["x-web-tracking-token"] = token;

    // Because your backend mounted webTrackingRoutes at '/'
    await fetch(`${ENDPOINT}/track`, {
      method: "POST",
      headers,
      keepalive: true,
      body: JSON.stringify(body),
    });
  } catch (err) {
    if (!options.silent) console.warn("track failed", err);
  }
}
